export default {"src":"/_next/static/image/src/images/Footer/info.e9ade36852794f5bacdf1c13443e56df.svg","height":17,"width":17};